import { Modal } from 'antd';
import React, { useState } from 'react';
import { ReactComponent as RawImage } from 'assets/svg/raw-image-notifi.svg';

const PopupConfirm = ({
  children,
  title,
  description,
  onOk,
  content,
  expand,
}) => {
  const [open, setOpen] = useState(false);

  const onOpen = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      {children({ onOpen, onClose })}
      <Modal
        onOk={onOk}
        open={open}
        onCancel={onClose}
        title={title || 'Confirm'}
        className="popup-confirm"
      >
        <div className="popup-confirm__image">
          <RawImage />
        </div>
        <div className='popup-confirm-wraper'>
          {content && <div className="popup-confirm__title">{content}</div>}
          {description && (
            <div className="popup-confirm__desc">{description}</div>
          )}
          {expand && <div className="popup-confirm__expand">{expand}</div>}
        </div>
      </Modal>
    </>
  );
};

export default PopupConfirm;
